import styled from 'styled-components';

export const MegaMenuStyled = styled.div`


.Brandshead{
  margin-left:2px;
}
.brands{
font-size:11px;
font-weight:700;
}


.category-w{
  height: 38px;
  display:flex;
  @media (max-width: 2600px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "2060px" : (props?.showLocation || props?.showStaticMegaMenu ? "2220px" : "2380px")};
  }
  @media (max-width: 2550px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1970px" : (props?.showLocation || props?.showStaticMegaMenu ? "2130px" : "2290px")};
  }
  @media (max-width: 2450px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1940px" : (props?.showLocation || props?.showStaticMegaMenu ? "2100px" : "2260px")};
  }
  @media (max-width: 2450px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1890px" : (props?.showLocation || props?.showStaticMegaMenu ? "2050px" : "2210px")};
  }
  @media (max-width: 2370px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1800px" : (props?.showLocation || props?.showStaticMegaMenu ? "1960px" : "2220px")};
  }
  @media (max-width: 2280px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1700px" : (props?.showLocation || props?.showStaticMegaMenu ? "1860px" : "2020px")};
  }
  @media (max-width: 2180px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1600px" : (props?.showLocation || props?.showStaticMegaMenu ? "1760px" : "1920px")};
  }
  @media (max-width: 2080px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1492px" : (props?.showLocation || props?.showStaticMegaMenu ? "1652px" : "1812px")};
  }
  @media (max-width: 1970px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1350px" : (props?.showLocation || props?.showStaticMegaMenu ? "1510px" : "1670px")};
  }
  @media (max-width: 1830px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1250px" : (props?.showLocation || props?.showStaticMegaMenu ? "1410px" : "1570px")};
  }
  @media (max-width: 1735px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1193px" : (props?.showLocation || props?.showStaticMegaMenu ? "1353px" : "1513px")};
  }
  @media (max-width: 1676px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1100px" : (props?.showLocation || props?.showStaticMegaMenu ? "1260px" : "1420px")};
  }
  @media (max-width: 1600px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1050px" : (props?.showLocation || props?.showStaticMegaMenu ? "1210px" : "1370px")};
  }
  @media (max-width: 1550px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "1000px" : (props?.showLocation || props?.showStaticMegaMenu ? "1160px" : "1320px")};
  }
  @media (max-width: 1485px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "930px" : (props?.showLocation || props?.showStaticMegaMenu ? "1090px" : "1106px")};
  }
  @media (max-width: 1390px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "850px" : (props?.showLocation || props?.showStaticMegaMenu ? "1010px" : "1170px")};
  }
  @media (max-width: 1300px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "750px" : (props?.showLocation || props?.showStaticMegaMenu ? "910px" : "1070px")};
  }
  @media (max-width: 1240px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "680px" : (props?.showLocation || props?.showStaticMegaMenu ? "840px" : "1000px")};
  }
  @media (max-width: 1200px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "650px" : (props?.showLocation || props?.showStaticMegaMenu ? "810px" : "970px")};
  }
  @media (max-width: 1140px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "600px" : (props?.showLocation || props?.showStaticMegaMenu ? "760px" : "920px")};
  }
  @media (max-width: 1080px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "550px" : (props?.showLocation || props?.showStaticMegaMenu ? "710px" : "870px")};
  }
  @media (max-width: 1050px){
    width:${(props) => props?.showLocation && props?.showStaticMegaMenu ? "500px" : (props?.showLocation || props?.showStaticMegaMenu ? "660px" : "820px")};
  }
  overflow-x:scroll;
  scrollbar-width: thin; 
  scrollbar-color: transparent transparent; 

  &::-webkit-scrollbar {
    display: none; 
  }

  &::-moz-scrollbar {
    display: none; 
  }
}
  .ic-arrow {
    transform: rotate(180deg);
    width: 6px;
    margin-left: 10px;
    height: 16px;
  }
  .text {
    margin-right: 8px;
  }
  
  .static-options {
    @media (max-width: 1900px){
    display: flex;
    flex-direction: row;
    box-shadow: -20px -5px 15px rgba(0, 0, 0, 0.1); 
    transition: box-shadow 0.3s ease; 
    .static-option {
      cursor: pointer;

      &:hover {
        box-shadow: -11px 4px 8px rgba(0, 0, 0,0.05); 
      }
    }
  }
}
@media (max-width: 2600px){
  display: flex;
  flex-direction: row;
  box-shadow: none;  
  .static-options-small{
    display: flex;
    flex-direction: row; 
    .static-option {
      cursor: pointer;
    }
  }
}
  
  .static-option.deals,
  .static-option.express {
    z-index: 30;
  }
  .option {
    display: flex;
    align-items: center;
  }

  .option.deals{
    padding:10px 12px;
    .dealsname{
      font-size:14px;
      font-weight:700;
    }
    .image{
      margin-right:3px;
      margin-top:2px;
    }
  }
  .option.express{
    position: relative; 
    right: -14px;
    .expressname{
      font-size:14px;
      font-weight:700;
    }
    .image_express{
      margin-right:3px;
      margin-top:2px;
    }
  }

  .static-card {
    background-color:${(props) => props.theme.color.white}; 
    border: 1px solid ${(props) => props.theme.color.white}; 
    height:38px;
    padding: 10px; 
    cursor: pointer;
    z-index: 20; 
  }
  
  .static-card.combined {
    display: flex;
    width:180px;
    justify-content: space-between;
    border-right: none;
    border-top:none;
    border-bottom:none;
  }
  
  .static-card.deals,
  .static-card.express {
    width: 48%; 
    background-color: #ffeb3b; 
    z-index: 30; 
  }

  .category-list {
    display: flex;
  }

  a{
    text-decoration: none;
    color: inherit;
  }
  .headLogo{
    padding-top:2px;
    padding-right:3px;
  }

  .category-namesbrand:hover  {
    width:98px;
    text-align: center;
    background-color:${(props) => props.theme.green.off}; 
    color:${(props) => props.theme.green.darkGreen};
 
  }
  

  .category-name {
    margin-right: 10px;
    padding-left: 15px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
  }
  .category-namebrand{
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
  }

  .category-names {
    width:max-content;
    display: flex;
    padding: 10px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    height: 38px;
    text-align: center;

    &.active{
      background: ${(props) => props.theme.grey.greyF4};
      color: ${(props) => props.theme.green.darkGreen};
    }
  }
  .category-namesbrand {
    width:98px;
    display: flex;
    padding-top: 10px;
    padding-left:15px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    height: 38px;
    text-align: center;
    &.active{
      background: ${(props) => props.theme.grey.greyF4};
      color: ${(props) => props.theme.green.darkGreen};
    }
  }

   .overlay {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    transition: all 0.05s ease-in;
    background: #00000075;
    z-index: 12;
   }
  .subcategory-list {
    display: flex;
    flex-direction: column;
    position: absolute;
    align-items: flex-start;
    justify-content: space-between;
    top: 101%;
    height: ${(props) => (props?.enlargeHeight > 12 ? (props?.enlargeHeight <= 16 ? '678px' : '744px') : '535px')};
    left: calc(48% - 1220px / 2);
    width: 1180px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    padding: 22px;
    background: #ffffff;
    z-index: 12;
   
  }
  .brandList {
    display: flex;
    left: 0;
    flex-direction: column;     
    position: absolute;
    align-items: flex-start;
    top: 101%;
    height: 360px;
    @media (max-width: 1500px){
    left: calc(48% - 1220px / 2);
    }
    @media (max-width: 2500px){
      left: none;
    }
    width: 1112px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    padding: 24px;
    background: ${(props) => props.theme.color.white};
    z-index: 12;
  
    .brandView {
      padding-bottom: 0px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      
    .view{
        padding-left:939px;
        color:${(props) => props.theme.green.darkGreen};

    }
    .viewIcon {
      margin-left: 4px;
    }
      
    }
    .brand-cards-container {
      display: grid;
      grid-template-columns: repeat(11, 1fr); 
      grid-gap: 16px; 
      justify-content: space-between;
      margin-top: 16px;
    }
    .brand-card:hover {
      border: 1px solid ${(props) => props.theme.green.darkGreen};
    }
    
    .brand-card {
      border-radius: 8px;
      border: 1px solid #e3e9ef;
      background: ${(props) => props.theme.color.white};
      padding-top: 22px;
      padding-left: 4px;
      padding-right: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 82px;
      width: 82px;
    }
    
    
  }

  .subCategoryLevel2{
    display:flex;
    justify-content: flex-start;
    border-right: 0.5px solid #E3E9EF !important;
    width: 27%;
    padding-right: 12px;
  }
  .catImage{
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 83px;
    height: 83px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #e3e9ef;
    border-radius: 8px;
    margin: 10px 16px 10px 0;
   }
   
  .catTitle {
    width: 82px;
    height: 25px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    text-align: center;
    color: #031a32;
  }
  .category-name:hover .subcategory-list {
    display: block;
  }
   .level2Category{
    display: flex; 
    width: 27%; 
    justify-content: space-between;
    border-right: 0.5px solid #E3E9EF !important;
   }
  .subcategory-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 8px;
    gap: 16px;
    width: 284px;
    height: 42px;
    border-radius: 8px;

    &.active {
      background: ${(props) => props.theme.grey.greyF4};
      color: ${(props) => props.theme.green.dark};
     }
  }

  .categoryBorder {
    display: flex; 
    width: 27%; 
    height: ${(props) => (props?.border <= 7 ? '36%' : '2%')};
    border-right: 0.5px solid #E3E9EF !important;
   }
   .category-wrapper-container {
    max-height: 38px; 
    overflow-y: auto; 
  }
  .category-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  @media (max-width: 1300px) {
    width:819px;
    .category-names {
      padding: 3px;
      font-size: 14px;
      align-items: center;
    }
    .static-options{
      padding-bottom:15px;
      height:40px;
    }
    .static-options-small{
      padding-bottom:15px;
      box-shadow: -20px -5px 15px rgba(0, 0, 0, 0.1); 
      height:40px;
    }
   
  }

  @media (max-width: 1000px) {
    padding: 5px 0;

    .category-wrapper {
      display: none;
  }
}

  @media (max-width: 480px) {
    padding: 10px 0;

    .category-wrapper {
      display: none;
  }
}
&.ksa {
  margin: 0 auto;
  max-width: 100%;
  .category-wrapper {
    max-width: 100%;
    .category-w {
      max-width: 100%;
      width: auto;
    }
  }
}
&.rtl {
  .category-namesbrand {
    padding-left: 0px;
    padding-right: 15px;
  }
  .headLogo {
    padding-right:0;
    padding-left:3px;
  }
  .Brandshead {
    margin-left:0;
    margin-right:2px;
  }
  .subcategory-list {
    .level2Category {
      border: 0 !important;
      border-left: 0.5px solid #E3E9EF !important;
    }
    .catImage{
      margin: 10px 0px 10px 16px;
    }
  }
  .brandList {
    left: auto;
    .brandView {
      .view {
        padding-left:0;
        padding-right:939px;
      }
    }
  }
}
`;
